import React from 'react';
import { PicklistPDFTemplate } from 'themes/modules/order/pages';

function PicklistPDF(props) {
	return <PicklistPDFTemplate {...props} />;
}

export default PicklistPDF;



// WEBPACK FOOTER //
// ./src/modules/order/pages/PicklistPDF.jsx